import { render, staticRenderFns } from "./SocialShareButton.vue?vue&type=template&id=1386d2aa&scoped=true&"
import script from "./SocialShareButton.vue?vue&type=script&lang=ts&"
export * from "./SocialShareButton.vue?vue&type=script&lang=ts&"
import style0 from "./SocialShareButton.vue?vue&type=style&index=0&id=1386d2aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386d2aa",
  null
  
)

export default component.exports